import { memo } from "react";

import { tw } from "classnames";

const styles = {
  image: tw(
    "box-border",
    "h-auto",
    "w-full",
    "animate-pulse",
    "bg-background-secondary",
    "pb-full"
  ),
  content: tw("mb-1", "mt-2", "box-border", "md:mt-4"),
  title: tw(
    "mb-3",
    "box-border",
    "h-5",
    "w-1/2",
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  descriptionLine1: tw(
    "box-border",
    "hidden",
    "h-3",
    "w-4/5",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "md:block",
    "mb-4"
  ),
  price: tw(
    "box-border",
    "h-4",
    "w-1/4",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "mb-2",
    "md:mb-0"
  ),
  spacer: tw("box-border", "h-3", "w-full", "md:h-4"),
  options: tw(
    "box-border",
    "h-5",
    "w-3/4",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "md:h-7"
  ),
  labelsContainer: tw("mt-4", "flex"),
  label1: tw(
    "mr-2",
    "box-border",
    "h-6",
    "w-20",
    "animate-pulse",
    "rounded",
    "bg-placeholder"
  ),
  label2: tw(
    "box-border",
    "h-6",
    "w-24",
    "animate-pulse",
    "rounded",
    "bg-placeholder",
    "hidden",
    "md:block"
  ),
};

const ProductCardPlaceholderBase = () => (
  <li>
    <div className={styles.image}></div>
    <div className={styles.content}>
      <div className={styles.title}></div>
      <div className={styles.descriptionLine1}></div>
      <div className={styles.price}></div>
      <div className={styles.spacer}></div>
      <div className={styles.options}></div>
      <div className={styles.labelsContainer}>
        <span className={styles.label1}></span>
        <span className={styles.label2}></span>
      </div>
    </div>
  </li>
);

export const ProductCardPlaceholder = memo(ProductCardPlaceholderBase);
